let $sliders = $('.js-slider');
let disableArrowsClass = 'flick-disable-arrows';

$sliders.each(function (i, el) {
	
	let $slider = $(el);
	
	$slider.flickity({
		cellAlign: 'left',
		contain: true,
		groupCells: true,
		// wrapAround: true,
		lazyLoad: 7,
		pageDots: true,
		imagesLoaded: true,
		dragThreshold: 50,
		on: {
			ready: function () {
				
				$.fn.matchHeight._update();
				
				arrowHide($slider);
				
				window.addEventListener("resize", function(){
					setTimeout(function(){
						arrowHide($slider)
					}, 200);
				});
				
			},
			select: function () {
				// arrowHide($slider);
			},
		},
	});
	
	// createDynamicDots($slider);
	createCountDots($slider);
	
});

function createDynamicDots($slider) {
	
	let $dynamicSlider = $('<div class="slider-dynamic-dots"></div>');
	
	for (let i = 0; i < $slider.data('flickity').cells.length; i++) {
		$dynamicSlider.append('<div class="slider-dynamic-dots__item"></div>');
	}
	
	$slider.after($dynamicSlider);
	
	$dynamicSlider.flickity({
		asNavFor: $slider[0],
		contain: false,
		pageDots: false,
		prevNextButtons: false,
		draggable: false,
	});
	
}

function createCountDots($slider) {
	
	let fl = $slider.data('flickity');
	$slider.on( 'change.flickity', updateCount);
	let $countDots = $('<div class="slider-count-dots"></div>');
	
	$slider.find('.flickity-page-dots').after($countDots);
	$slider.trigger('change.flickity');
	
	function updateCount() {
		
		let cellNumber = fl.selectedIndex + 1;
		$countDots.text( cellNumber + '/' + fl.slides.length );
		
	}
	
	window.addEventListener("resize", updateCount);
	
}

function arrowHide($slider) {
	
	let isAllArrowsDisabled = ( $slider.find('.flickity-slider>*').length === $slider.find('.flickity-slider>*').filter('.is-selected').length );
	
	if(isAllArrowsDisabled) {
		$slider.addClass(disableArrowsClass);
	}
	else {
		$slider.removeClass(disableArrowsClass);
	}
	
}